module.exports = __webpack_public_path__ + "static/media/heroes-one.02d47271.png";